module.exports = __webpack_public_path__ + "static/media/shichayak.36e5f9a4.ogg";